import React from "react";
import cloneDeep from "lodash/cloneDeep";
import get from "lodash/get";
import find from "lodash/find";
import lround from "lodash/round";
import submit from "submit-form";
import convert from "convert-units";

import SingleDayCycleBar from "../../dashboard/calendar/components/SingleDayCycleBar";
import getSessionOrder from "../../../utils/get-session-order";
import QuickMetrics from "../../dashboard/calendar/components/QuickMetrics";
import TopBarSingleDay from "../../dashboard/calendar/components/TopBarSingleDay";

import {
  validateSet,
  checkOtherExercise,
} from "../../../utils/exercise-validations";

import moment from "moment";
import DaylyWorkoutHeader from "../../dashboard/calendar/DaylyWorkoutHeader";
import ExerciseFrame from "../../dashboard/calendar/ExerciseFrame";
import VideoRecordComponent from "../../../parts/VideoRecordComponent";
import PhotoModal from "./progress-photos/PhotoModal";
import Picture from "./progress-photos/Picture";
import addMetadata from "../../../utils/add-metadata";

import DatePicker from "../../../parts/DatePicker";

// Constants
import {
  DATE_FORMATS,
  defaultFirebaseProjectId,
  PRIMARIESWITHOLYMPIC,
  S3,
} from "../../../constants";
import SvgIcon from "../../../parts/SvgIcon";
import { AthleteLinks } from "../../../parts/athlete-links";
import getAvatarUrl from "../../../utils/get-avatar-url";
import { AthleteSelect } from "../../../parts/inputs/athlete-select-new";
import ToggleLinksInput from "../../../parts/inputs/toggle-links-input";
import Avatar from "../../../parts/avatar";

const { DATE_YEAR_FORMAT, DATE_DAY_FORMAT } = DATE_FORMATS;

class View extends React.Component {
  constructor(props, context) {
    super(props);
    const { activeUser, athlete } = context.locals;
    this.user = activeUser;
    this.activeUser = athlete || activeUser;
    this.state = {
      coachNotes: "",
      openQuickEdit: false,
      openQuickEditCoachNotes: false,
      exercises: [],
      photoModal: {
        open: false,
        type: "",
        pictureImg: "",
      },
    };
    this.loadInputs = [];
    this.intensityInputs = [];
    this.handleDuplicateExercise = this.handleDuplicateExercise.bind(this);
    this.openQuickEditMode = this.openQuickEditMode.bind(this);
    this.handleQuickEditChange = this.handleQuickEditChange.bind(this);
    this.saveQuickEdit = this.saveQuickEdit.bind(this);
    this.closeQuickEditMode = this.closeQuickEditMode.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { editedExercise, setIndex } = this.props;
    if (
      editedExercise &&
      (editedExercise !== prevProps.editedExercise ||
        setIndex !== prevProps.setIndex)
    ) {
      const updatedExercise = this.context.locals.activeExercises.find(
        (ex) => ex._id === editedExercise
      );
      const stateExercise = this.state.exercises.find(
        (ex) => ex._id === editedExercise
      );
      if (
        stateExercise &&
        updatedExercise &&
        stateExercise.sets?.length !== updatedExercise.sets?.length
      ) {
        this.setState((prevState) => {
          const copyExercises = [...prevState.exercises];
          const exerciseIndex = copyExercises.findIndex(
            (elem) => elem._id === editedExercise
          );
          if (exerciseIndex > -1) {
            const setsCopy = [...copyExercises[exerciseIndex].sets];
            setsCopy.splice(
              setIndex + 1,
              0,
              updatedExercise.sets[setIndex + 1]
            );
            copyExercises[exerciseIndex].sets = setsCopy;
          }
          return { exercises: copyExercises };
        });
      }
    }
  }

  toggleModal(pictureImg = "", type = "") {
    this.setState({
      photoModal: {
        open: this.state.photoModal.open ? false : true,
        type,
        pictureImg: S3.toCDN(pictureImg),
      },
    });
  }

  handleDuplicateExercise(body, proxyAthlete) {
    submit(
      `/actions/exercise/duplicate-from-single-day?proxyAthlete=${proxyAthlete}`,
      {
        method: "POST",
        body,
      }
    );
  }

  openQuickEditMode(e) {
    e.preventDefault();
    this.setState((prevState) =>
      Object.assign({}, prevState, { openQuickEdit: true })
    );
  }

  closeQuickEditMode(e) {
    e && e.preventDefault();
    document.getElementById("quick-edit").reset();
    this.setState((prevState) =>
      Object.assign({}, prevState, { openQuickEdit: false })
    );
  }

  handleQuickEditChange({ target: { name, value } }, exId, setId) {
    const { locals } = this.context;
    const exercises = cloneDeep(this.state.exercises);
    const exerciseIndex = exercises.findIndex((ex) => ex._id == exId);
    const exercise =
      exercises[exerciseIndex] ||
      cloneDeep(get(locals, "activeExercises", [])).find(
        (ex) => ex._id == exId
      ) ||
      cloneDeep(get(locals, "editExercises", [])).find(
        (ex) => ex._id == exId
      ) ||
      {};

    const set = get(exercise, ["sets", setId], false);

    if (["load", "percentRepMax", "loadDrop"].includes(name)) {
      if (String(value).includes(",")) {
        value = String(value).replace(",", ".");
      }
    }

    if (set && set[name] !== value && name !== "exerciseType") {
      set[name] = value;
      const primary = get(exercise, "primary");
      const repMax =
        exercise.type != "secondary"
          ? get(
              exercise,
              `repMaximums.${primary}`,
              get(this.activeUser, `repMaximums.${primary}`, 0)
            )
          : exercise.secondaryRepMaximum;

      // ensure load and percentRepMax are in sync
      if (name === "load") {
        if (locals.activeUser.units === "imperial") {
          set.load = lround(convert(value).from("lb").to("kg"), 2);
        }

        if (exercise.type !== "assistant")
          set.percentRepMax = lround((set.load / repMax) * 100, 1);
      }

      if (name === "percentRepMax")
        set.load = lround((repMax * set.percentRepMax) / 100, 2);

      const loadInput = this.loadInputs[`${exId}_${setId}`];
      if (loadInput) {
        if (name === "percentRepMax") {
          let loadToShow = set.load;
          if (locals.activeUser.units === "imperial") {
            loadToShow = lround(convert(loadToShow).from("kg").to("lb"), 2);
          }
          loadInput.value = loadToShow;
        }
        if (!this.intensityInputs[`${exId}_${setId}`]) {
          this.intensityInputs[`${exId}_${setId}`] = { value: 0 };
        }
        this.intensityInputs[`${exId}_${setId}`].value = set.percentRepMax;
      }

      const validatedSet = validateSet({
        exercise,
        set,
        locals,
        field: name,
      });
      if (validatedSet) {
        exercise.sets[setId] = validatedSet;
        this.setExersicesStates(exercise, exercises, exerciseIndex);
      } else {
        // revert to original value
        document.getElementById(`${exId}_${setId}_${name}`).value = cloneDeep(
          get(locals, "activeExercises", [])
        ).find((ex) => ex._id == exId).sets[setId][name];
      }
    } else if (name === "notes") {
      exercise.notes = value === "" ? " " : value;

      this.setExersicesStates(exercise, exercises, exerciseIndex);
    } else if (name === "exerciseType") {
      const { movement, repMaximum, newPrimary } = value;
      const sets = get(exercise, "sets", false);

      addMetadata(
        exercise,
        movement,
        newPrimary,
        locals.activeUserToRequest.primaryExercises,
        locals.activeUserToRequest.exerciseLibrary
      );

      // if the movement chosen is a primary, change to a primary
      if (PRIMARIESWITHOLYMPIC.includes(movement)) {
        // setting new values
        exercise.type = "primary";
        exercise.primary = movement;
        // resetting secondary and secondary RM
        exercise.secondary = "null";
        exercise.secondaryRepMaximum = 0;
        exercise.parameters = "null";
        // updating the values of each set in the exercise
        sets.map((currentSet, idx) => {
          if (
            currentSet.load &&
            currentSet.percentRepMax &&
            currentSet.load >= 0 &&
            currentSet.percentRepMax >= 0
          ) {
            currentSet.load = lround(
              (repMaximum * currentSet.percentRepMax) / 100,
              2
            );
            currentSet.percentRepMax = lround(
              (currentSet.load / repMaximum) * 100,
              1
            );
          }

          // updating the load shown
          const loadInput = this.loadInputs[`${exId}_${idx}`];
          if (loadInput) {
            let loadToShow = currentSet.load;
            const { units } = this.context.locals.activeUser;

            if (units === "imperial") {
              loadToShow = lround(convert(loadToShow).from("kg").to("lb"), 2);
            }
            loadInput.value = loadToShow;
          }
          // Making sure no values are invalid after any changes
          if (!currentSet.load || currentSet.load === null) currentSet.load = 0;
          if (!currentSet.percentRepMax || currentSet.percentRepMax === null)
            currentSet.percentRepMax = 0;
          if (!currentSet.sets) currentSet.sets = 1;
          if (!currentSet.reps) currentSet.reps = 1;
          if (!currentSet.load && !currentSet.rpe) currentSet.rpe = 5;
        });
      }
      // if repMaximum is undefined and isAssistant = true then it is assistant
      else if (!repMaximum && newPrimary === "assistant") {
        exercise.type = "assistant";
        exercise.primary = "assistant";
        exercise.secondary = movement;
        exercise.secondaryRepMaximum = 0;
        if (value.parameters) exercise.parameters = value.parameters;
      }
      // else its a secondary
      else {
        // change type from primary/assistant to secondary and set new values
        exercise.type = "secondary";
        exercise.primary = newPrimary;
        exercise.secondary = movement;
        exercise.secondaryRepMaximum = repMaximum;
        exercise.parameters = "null";
        // updating the values of each set in the exercise
        sets.map((currentSet, idx) => {
          if (
            currentSet.load &&
            currentSet.percentRepMax &&
            currentSet.load >= 0 &&
            currentSet.percentRepMax >= 0
          ) {
            currentSet.load = lround(
              (repMaximum * currentSet.percentRepMax) / 100,
              2
            );
            currentSet.percentRepMax = lround(
              (currentSet.load / repMaximum) * 100,
              1
            );
          }

          // updating the load shown
          const loadInput = this.loadInputs[`${exId}_${idx}`];
          if (loadInput) {
            let loadToShow = currentSet.load;
            const { units } = this.context.locals.activeUser;

            if (units === "imperial") {
              loadToShow = lround(convert(loadToShow).from("kg").to("lb"), 2);
            }
            loadInput.value = loadToShow;
          }
          // Making sure no values are invalid after any changes
          if (!currentSet.load || currentSet.load === null) currentSet.load = 0;
          if (!currentSet.percentRepMax || currentSet.percentRepMax === null)
            currentSet.percentRepMax = 0;
          if (!currentSet.sets) currentSet.sets = 1;
          if (!currentSet.reps) currentSet.reps = 1;
          if (!currentSet.load && !currentSet.rpe) currentSet.rpe = 5;
        });
      }

      this.setExersicesStates(exercise, exercises, exerciseIndex, true);
    }
  }

  setExersicesStates(
    exercise,
    exercises,
    exerciseIndex,
    saveAfterChange = false
  ) {
    // if exercise already exists in state
    if (exerciseIndex > -1) exercises[exerciseIndex] = exercise;
    // otherwise push to exercises
    if (exerciseIndex < 0) exercises.push(exercise);

    this.setState(
      (prevState) => Object.assign({}, prevState, { exercises }),
      saveAfterChange
        ? () =>
            this.saveQuickEdit(
              { preventDefault: () => {} },
              this.context.locals.query.athlete,
              false
            )
        : undefined
    );
  }

  saveQuickEdit(e, proxyAthlete, close = true) {
    e.preventDefault();

    if (
      this.state.exercises === undefined ||
      this.state.exercises.length === 0
    ) {
      this.closeQuickEditMode();
      this.setState({ exercises: [] });
      submit("/actions/exercise/quick-edit/cancel");
    } else if (checkOtherExercise(this.state.exercises)) {
      const exercises = this.state.exercises.map((ex) => {
        ex.date = ex.originalDate;
        let movementLibrary = {};
        if (ex.secondary) {
          const libraryCoach = get(
            this.context.locals.activeUser,
            `exerciseLibrary.${ex.primary}`,
            []
          );

          const existsCoach = find(libraryCoach, {
            movement: ex.secondary,
          });

          if (existsCoach) {
            existsCoach.primary = ex.primary;
            ex.movementLibrary = existsCoach;
          }
        }
        return ex;
      });
      //Fixes CH-1490
      submit(
        `/actions/exercise/quick-edit?proxyAthlete=${proxyAthlete}&reqSource=calendar`,
        {
          method: "POST",
          body: { exercises },
        }
      );
      if (close) {
        this.setState({ exercises: [] });
        this.closeQuickEditMode();
      }
    }
  }

  openQuickEditCoachNotes() {
    const workoutCoachNote = this.context.locals.workoutCoachNote;
    this.setState(
      {
        openQuickEditCoachNotes: true,
        coachNotes:
          workoutCoachNote &&
          workoutCoachNote.note &&
          workoutCoachNote.note.note
            ? workoutCoachNote.note.note
            : "",
      },
      () => {
        document.getElementById("coach-notes-textarea")?.focus();
      }
    );
  }

  closeQuickEditCoachNotes() {
    this.setState({ openQuickEditCoachNotes: false });
  }

  handleCoachNoteChange(value) {
    this.setState({ coachNotes: value });
  }

  saveQuickEditCoachNotes() {
    const { originalQueryDate, query, activeUser, activeUserToRequest } =
      this.context.locals;

    submit("/actions/exercise/quick-edit-coach-note", {
      method: "POST",
      body: {
        note: this.state.coachNotes,
        date: originalQueryDate,
        user: query.athlete,
        coach: query.organizationCoach || activeUser._id,
        avatar:
          !!activeUser.avatar && !!activeUser.avatar.file
            ? activeUser.avatar.file
            : null,
        firebaseProjectId: !!activeUserToRequest.firebaseProjectId
          ? activeUserToRequest.firebaseProjectId
          : defaultFirebaseProjectId,
      },
    });

    if (
      this.context.locals.workoutCoachNote &&
      this.context.locals.workoutCoachNote.note &&
      this.context.locals.workoutCoachNote.note.note
    ) {
      this.context.locals.workoutCoachNote.note.note = this.state.coachNotes;
    } else {
      this.context.locals.workoutCoachNote = {
        note: { note: this.state.coachNotes },
      };
    }

    this.closeQuickEditCoachNotes();
  }

  renderBodyPhotos(activeDay = null) {
    const {
      locals: { dailyStats, query },
    } = this.context;
    const existPhotos =
      dailyStats.find(
        (stat) => stat.bodyPhotos && activeDay.isSame(stat.date)
      ) || false;
    if (!existPhotos) return null;
    const { athlete } = query;
    const urlStart = athlete ? "/athlete-portal/metrics" : "/dashboard/metrics";
    const urlEnd = athlete ? `&athlete=${athlete}` : "";
    const date = activeDay.format(DATE_DAY_FORMAT);
    return (
      <div className="progress-photo-wrapper">
        <span>Progress Photos</span>
        <div className="photos-container">
          {["front", "back", "side"].map((photoType, idx) => {
            const pictureSrc = existPhotos.bodyPhotos[photoType] || null;
            return (
              <Picture
                key={idx}
                src={pictureSrc ? pictureSrc.s3Path : pictureSrc}
                toggleModal={this.toggleModal}
                className="body-photo"
                photoType={photoType}
                loaded
              />
            );
          })}
        </div>
        <a
          href={`${urlStart}/progress-photos?view=day&date=${date}${urlEnd}`}
          data-button-type="text"
          role="button"
        >
          See all
        </a>
      </div>
    );
  }

  renderNotes({
    notes,
    coachNotes,
    athleteInfo,
    activeUserToRequest,
    coachOrganizationInformation,
  }) {
    return (
      <div className="notes-container">
        <div className="coach-notesx">
          <label>Notes</label>
          <>
            {!this.state.openQuickEditCoachNotes ? (
              <div
                className="edit-mode"
                onClick={() => this.openQuickEditCoachNotes()}
              >
                <div className="only-show-mobile">
                  {coachNotes.trim().length ? (
                    <Avatar
                      size={32}
                      className={`note-avatar only-show-mobile`}
                      user={coachOrganizationInformation}
                    />
                  ) : null}
                  <div>
                    {coachNotes.trim().length ? (
                      <span className={`coach-name`}>
                        {athleteInfo &&
                          athleteInfo.coach &&
                          athleteInfo.coach.name}
                      </span>
                    ) : null}
                    <span className="click-add">
                      {coachNotes.trim().length
                        ? coachNotes
                        : "Tap to add note"}
                    </span>
                  </div>
                </div>
                <span className="mobile-hidden">
                  {coachNotes.trim().length
                    ? coachNotes
                    : "Click to add/edit notes"}
                </span>
              </div>
            ) : (
              <div className="edit-mode editing">
                <textarea
                  value={this.state.coachNotes || ""}
                  onChange={({ target: { value } }) =>
                    this.handleCoachNoteChange(value)
                  }
                  id="coach-notes-textarea"
                />
                <div className="button-container">
                  <button
                    data-button-type="primary"
                    onClick={() => this.saveQuickEditCoachNotes()}
                  >
                    Save
                  </button>
                  <button
                    data-button-type="secondary"
                    onClick={() => this.closeQuickEditCoachNotes()}
                  >
                    <SvgIcon
                      src="/img/new-icons/red-cross.svg"
                      noFilterOnLight={true}
                    />
                  </button>
                </div>
              </div>
            )}
          </>
        </div>
        {notes && notes.trim().length ? (
          <div className="athlete-notes">
            <label>
              {activeUserToRequest.referAsClients
                ? "Client Notes"
                : "Athlete Notes"}
            </label>
            <div className="edit-mode !cursor-default">
              <span className={`athlete-name only-show-mobile`}>
                {athleteInfo && athleteInfo.name}
              </span>
              <span>{notes}</span>
            </div>
          </div>
        ) : null}
      </div>
    );
  }

  render() {
    const { locals } = this.context;
    const {
      query,
      activeExercises,
      editExercises,
      editCycle,
      cycleDetail = {},
      workoutNote,
      workoutCoachNote,
      athlete: athleteInfo,
      pathname,
      activeUserToRequest,
      coachOrganizationInformation,
    } = locals;
    const { comesFromPR } = this.props;
    const notes =
      workoutNote && workoutNote.note && workoutNote.note.note
        ? workoutNote.note.note
        : "";

    const coachNotes =
      workoutCoachNote && workoutCoachNote.note && workoutCoachNote.note.note
        ? workoutCoachNote.note.note
        : "";

    const { athlete } = query;
    const activeUser = this.activeUser;
    const user = this.user;
    const nav = query.nav || "0";

    const program = find(get(editCycle, "programs", []), {
      order: cycleDetail.program,
    });
    const sessionOrderInProgram = program
      ? getSessionOrder(
          program,
          cycleDetail.programWeek,
          cycleDetail.programSession
        )
      : undefined;
    const session = find(get(program, "sessions", []), {
      order: sessionOrderInProgram,
    });

    const activeDay = moment(query.date, DATE_DAY_FORMAT);
    const { photoModal } = this.state;

    const dailyStats = locals.dailyStats.find((stats) => {
      const utcDate = parseInt(activeDay.format("YYYYMMDD"));
      return stats.utcDate === utcDate;
    });

    return (
      <main className="Calendar Calendar-Day">
        <TopBarSingleDay
          query={query}
          activeDay={activeDay}
          isAthlete={true}
          dateClassNames={"mobile-hidden"}
          comesFromPR={comesFromPR}
          {...{ locals }}
        />

        <div className="athlete-section-header only-show-mobile">
          <AthleteLinks
            athlete={athleteInfo}
            pathName={pathname}
            classNames={"only-show-mobile"}
            query={query}
          />
          <div>
            <div className="athlete-select dropdown-athlete">
              <div
                className="avatar"
                style={{
                  backgroundImage: `url(${getAvatarUrl(athleteInfo?._id)})`,
                }}
              />
              <AthleteSelect locals={this.context.locals} />
            </div>
            <ToggleLinksInput
              name="view"
              options={[
                {
                  text: "Month",
                  value: "month",
                  href: `/actions/refresh?view=month&month=${
                    query.week
                      ? moment(query.week, DATE_DAY_FORMAT).format(
                          DATE_YEAR_FORMAT
                        )
                      : query.date
                      ? moment(query.date, DATE_DAY_FORMAT).format(
                          DATE_YEAR_FORMAT
                        )
                      : ""
                  }&week=&date=`,
                },
                {
                  text: "Day",
                  value: "day",
                  href: `/actions/refresh?view=day&date=${
                    moment().isSame(query.month, "month")
                      ? moment().format(DATE_DAY_FORMAT)
                      : moment(query.month, DATE_YEAR_FORMAT).format(
                          DATE_DAY_FORMAT
                        )
                  }&month=&week=`,
                },
              ]}
            />
          </div>
        </div>

        <DatePicker {...{ locals }} />

        <section className="Calendar-Day">
          {editCycle && (
            <SingleDayCycleBar
              exerciseCycleDetails={cycleDetail}
              cycle={editCycle}
              cycleExercises={editExercises}
              exercises={activeExercises}
              activeDay={activeDay}
              setSessionOrder={this.setSessionOrder}
              nav={nav}
              isAthlete={true}
              pathname={pathname}
            />
          )}
          <section className="Daily-Workout">
            <DaylyWorkoutHeader
              activeExercises={activeExercises}
              sessionOrderInProgram={sessionOrderInProgram}
              query={query}
              openQuickEditMode={this.openQuickEditMode}
              handleRemove={(e) => handleRemove(e, activeDay, athlete)}
              dailyStats={dailyStats}
              activeUser={user}
              activeDay={activeDay}
            />

            <ExerciseFrame
              activeExercises={activeExercises}
              openQuickEdit={this.state.openQuickEdit}
              editCycle={editCycle}
              program={program}
              session={session}
              fromMetric={locals.fromMetric}
              activeUser={activeUser}
              handleDuplicate={(exercise) =>
                this.handleDuplicateExercise(exercise, athlete)
              }
              openQuickEditMode={this.openQuickEditMode}
              handleQuickEditChange={this.handleQuickEditChange}
              loadInputs={this.loadInputs}
              intensityInputs={this.intensityInputs}
              query={query}
              saveQuickEdit={(e) => this.saveQuickEdit(e, athlete)}
              exercises={this.state.exercises}
              closeQuickEditMode={this.closeQuickEditMode}
              handleRemove={(e) => handleRemove(e, activeDay, athlete)}
            />

            <footer>
              <div>
                <VideoRecordComponent
                  date={activeDay.format(DATE_DAY_FORMAT)}
                  unformattedDate={activeDay}
                  videoRecordEmbed={
                    locals.videoRecord ? locals.videoRecord.embedUrl : null
                  }
                  locals={locals}
                />
                {this.renderBodyPhotos(activeDay)}
              </div>
              <div className="separator-line only-show-mobile" />
              {this.renderNotes({
                notes,
                coachNotes,
                athleteInfo,
                activeUserToRequest: activeUser,
                coachOrganizationInformation,
              })}
            </footer>
          </section>
          <hr />
          <QuickMetrics locals={locals} />
        </section>

        {photoModal.open ? (
          <PhotoModal toggleModal={this.toggleModal} photo={photoModal} />
        ) : null}
      </main>
    );
  }
}

function handleRemove(e, date, athlete) {
  if (confirm("Are you sure you want to remove this workout?")) {
    e.preventDefault();

    submit(
      `/actions/exercise/unschedule-workout?date=[${date.format(
        DATE_DAY_FORMAT
      )}]&proxyAthlete=${athlete}`,
      {
        method: "POST",
        body: {
          days: [date.format(DATE_DAY_FORMAT)],
          source: "calendarDayView",
        },
      }
    );
  }
}

export default View;
